import React from 'react'
import classNames from 'classnames'

import { calculatePackageCount } from '~/components/dashboard/admin/catalog/inventory/inventoryUtils'
import { getInventoryItemDisplayQuantity } from '~/utils/inventoryItemUtils'

import styles from './FormattedQuantityDisplay.module.scss'

export type FormattedQuantityDisplayVariant =
  | 'receiving'
  | 'rejecting'
  | 'remaining'

interface FormattedQuantityDisplayProps {
  className?: string
  packageTypeName: string
  packageUnitsName: string
  perPackageAmount: number
  quantity: number
  variant?: FormattedQuantityDisplayVariant
}

export const FormattedQuantityDisplay = ({
  className,
  packageTypeName,
  packageUnitsName,
  perPackageAmount,
  quantity,
  variant,
}: FormattedQuantityDisplayProps) => {
  const packageQuantity = calculatePackageCount(quantity, perPackageAmount)
  const { total, breakdown } = getInventoryItemDisplayQuantity({
    orderedQuantity: packageQuantity,
    perPackageAmount,
    productSizeUnit: packageUnitsName,
    packageType: packageTypeName,
    originalQuantity: quantity,
    breakdownStyle: 'simplified',
  })

  return (
    <span
      className={classNames(
        styles.container,
        variant && styles[variant],
        className,
      )}
    >
      <span className={styles.consumption}>{total}</span>
      {breakdown && <span className={styles.package}>({breakdown})</span>}
    </span>
  )
}
